import {
    IconButton,
    Tooltip,
} from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import { useConteosEscaneo } from "../../../../context/ConteosEscaneo/ConteosEscaneoContext";
import { useDoubleClickPrevention } from "../../../../hooks/useDoubleClickPrevention";

export default function MnuConteosEscaneoActions({
    selectedScanPk,
    hasActiveConteo,
    onConfirmEliminarPartida,
    onConfirmEliminarCompleto,
    onBuscar,
    onNuevoConteo,
    onCargarCatalogo,
    cargandoCatalogo,
    storageLecturasKey,
    onGuardar,
}) {

    const {
        handleClickRegresarMainDashboard,
        handleCrearScansLote,
        handleNuevoConteo,
    } = useConteosEscaneo();

    // El padre (Frm) limpia además selección y pendientes locales; si no hay
    // prop, se usa el del contexto.
    const nuevoConteo = onNuevoConteo || handleNuevoConteo;

    const {
        isProcessing,
        executeWithProtection,
    } = useDoubleClickPrevention();

    const guardar = async () => {
        if (onGuardar) {
            await onGuardar();
            return;
        }
        if (storageLecturasKey) {
            try {
                const raw = localStorage.getItem(storageLecturasKey);
                if (raw) {
                    const pendientes = JSON.parse(raw);
                    const codigos = (Array.isArray(pendientes) ? pendientes : [])
                        .map((item) => (typeof item === "string" ? item : item.codigo))
                        .filter(Boolean);
                    if (codigos.length > 0) {
                        await handleCrearScansLote(codigos);
                    }
                }
            } catch { }
            try { localStorage.removeItem(storageLecturasKey); } catch { }
        }
    };

    const salirConGuardado = async () => {
        await guardar();
        handleClickRegresarMainDashboard();
    };

    return (
        <>
            <Tooltip title="Salir">
                <span>
                    <IconButton
                        disabled={isProcessing}
                        onClick={() =>
                            executeWithProtection(salirConGuardado)
                        }
                    >
                        <HomeIcon className="icon" />
                        <p className="icon">Salir</p>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Guardar lecturas pendientes">
                <span>
                    <IconButton
                        disabled={isProcessing}
                        onClick={() =>
                            executeWithProtection(guardar)
                        }
                    >
                        <SaveIcon className="icon" />
                        <p className="icon">Guardar</p>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Nuevo conteo">
                <span>
                    <IconButton
                        disabled={isProcessing}
                        onClick={() =>
                            executeWithProtection(nuevoConteo)
                        }
                    >
                        <AddCircleOutlineIcon className="icon" />
                        <p className="icon">Nuevo</p>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Buscar artículo en inventario (Alt+F1)">
                <span>
                    <IconButton
                        disabled={isProcessing}
                        onClick={() =>
                            executeWithProtection(onBuscar)
                        }
                    >
                        <SearchIcon className="icon" />
                        <p className="icon">Buscar</p>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Cargar catálogo completo de la toma (manual, con progreso)">
                <span>
                    <IconButton
                        disabled={isProcessing || cargandoCatalogo}
                        onClick={() =>
                            executeWithProtection(onCargarCatalogo)
                        }
                    >
                        <DownloadIcon className="icon" />
                        <p className="icon">Catálogo</p>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Eliminar lectura">
                <span>
                    <IconButton
                        disabled={
                            isProcessing ||
                            !selectedScanPk
                        }
                        onClick={() =>
                            executeWithProtection(onConfirmEliminarPartida)
                        }
                    >
                        <DeleteIcon className="icon" />
                        <p className="icon">Eliminar</p>
                    </IconButton>
                </span>
            </Tooltip>

            <Tooltip title="Eliminar conteo">
                <span>
                    <IconButton
                        disabled={
                            isProcessing ||
                            !hasActiveConteo
                        }
                        onClick={() =>
                            executeWithProtection(onConfirmEliminarCompleto)
                        }
                    >
                        <DeleteSweepIcon className="icon" />
                        <p className="icon">Eliminar todo</p>
                    </IconButton>
                </span>
            </Tooltip>
        </>
    );
}